import {
  SHOW_QUESTION_MODAL,
  HIDE_QUESTION_MODAL,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    display: false,
    modalTitle: '',
    questionText: '',
    questionTextAppend: '',
    hyperLinkUrl: '',
    hyperLinkText: '',
    hyperLinkUrl2: '',
    hyperLinkText2: '',
    methodToExecute: '',
    yesButtonText: '',
    hideCancelButton: false,
  },
  mutations: {
    [SHOW_QUESTION_MODAL](state, data) {
      const { title, question, questionAppend,
        hyperLinkUrl, hyperLinkText, hyperLinkUrl2, hyperLinkText2, method,
        yesButtonText, hideCancelButton } = data;

      state.display = true;
      state.hideCancelButton = hideCancelButton;
      state.modalTitle = title;
      state.questionText = question;
      state.questionTextAppend = questionAppend;
      state.hyperLinkUrl = hyperLinkUrl;
      state.hyperLinkText = hyperLinkText;
      state.hyperLinkUrl2 = hyperLinkUrl2;
      state.hyperLinkText2 = hyperLinkText2;
      state.methodToExecute = method;
      state.yesButtonText = yesButtonText;
    },
    [HIDE_QUESTION_MODAL](state) {
      state.display = false;
      state.hideCancelButton = true;
      state.modalTitle = '';
      state.questionText = '';
      state.questionTextAppend = '';
      state.hyperLinkUrl = '';
      state.hyperLinkText = '';
      state.hyperLinkUrl2 = '';
      state.hyperLinkText2 = '';
      state.methodToExecute = '';
      state.yesButtonText = '';
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/question.js